import { isAvatarSrc, thumbnailMediumBlue } from '@utils/thumbnails'
import { useAuthContext } from '@contexts/authContext'
import useModalContext from '@contexts/modalContext'
import { colors, size } from '@styles/theme'
import { formatDistance } from 'date-fns'
import styled from '@emotion/styled'
import clamp from 'clamp-js'

import AtAGlanceDetails from '@components/nearby/AtAGlanceDetails'
import ProfileNavigateAvatar from '@elements/ProfileNavigateAvatar'
import RegisteredIndicator from '@elements/RegisteredIndicator'
import { PiStarFill } from 'react-icons/pi'
import { ButtonBase, } from '@mui/material'

const ContainerButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  padding: 0.65rem 0.75rem 0.65rem 1.25rem;
  justify-content: flex-start;
  text-align: left;
  overflow: hidden;
  width: 100dvw;
`

const UserDetails = styled.div`
  width: 100%;
  overflow: hidden;
`

const DetailsTop = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
`

const DetailsUserName = styled.span`
  max-width: ${size(26)};
  font-size: 16px;
`

const ConversationListItem = ({ conversation }) => {
  const { state } = useAuthContext()
  const { messagesModal } = useModalContext()
  const { users, mostRecentMessage } = conversation
  const user = state?.user?.uuid && users.find((u) => u.uuid !== state?.user?.uuid)
  const userStatusColor = ((user?.tempStatus && user.tempStatus !== 'browsing') ? colors.statusColors[user?.tempStatus]('primary') : 'transparent')
  // const userStatusColorLight = (user?.tempStatus ? colors.statusColors[user?.tempStatus]('lightRgba')('0.1') : 'black')
  const isAvatar = isAvatarSrc('medium', user?.nearbyMedia?.thumbnails?.[0], user?.defaultAvatar)

  const theySentMessage = (
    user?.nearbyUuid &&
    mostRecentMessage?.userUuid &&
    mostRecentMessage?.userUuid === user?.nearbyUuid
  )

  const greyBody = (
    !theySentMessage ||
    (theySentMessage && !!mostRecentMessage?.seenAt)
  )

  // const containerBackgroundColor = () => {
  //   if (greyBody) {
  //     return 'black'
  //   } else if (user?.tempStatus === 'browsing') {
  //     return 'rgba(255,255,255,0.1)'
  //   } else {
  //     return userStatusColorLight
  //   }
  // }

  const renderUserName = () => {
    return (
      <div style={{ duisplay: 'flex', alignItems: 'center' }}>
        <RegisteredIndicator
          user={user}
          style={{
            opacity: 0.5,
            marginRight: size(1),
            marginBottom: size(-0.25)
          }}
        />
        {user?.extendedInfos?.tagline ||
          <AtAGlanceDetails
            displayRegisteredIcon={false}
            wrappable={false}
            capitalizeEach
            hasUserSuffix
            user={user}
            textOnly
          />
        }
      </div>
    )
  }

  // TODO: This is done really wonky because you intend to place this logic (or something like it) into a reusable utility
  const renderDate = (date) => {
    try {
      let time = formatDistance(date, Date.now())
      time = time.replace('about ', '')
      if (time === 'less than a minute') {
        return 'now'
      } else if (time.slice(time.length - 6) === 'minute') {
        return time.replace('minute', 'min')
      } else if (time.slice(time.length - 7) === 'minutes') {
        return time.replace('minutes', 'mins')
      } else if (time.slice(time.length - 4) === 'hour') {
        return time.replace('hour', 'hr')
      } else if (time.slice(time.length - 5) === 'hours') {
        return time.replace('hours', 'hrs')
      } else {
        return time
      }
    } catch {
      return ''
    }
  }

  const renderDateCreated = () => {
    if (mostRecentMessage?.createdAt) {
      return renderDate(mostRecentMessage?.createdAt)
    }
  }

  const handleMessageNavigation = (e) => {
    e.preventDefault()
    const isProfileNavigation = e.target.classList.contains('MuiAvatar-img')
    if (!isProfileNavigation) {
      messagesModal.open({ pathname: 'conversations', search: { conversation_id: conversation.uuid } }, { state: { user, conversation, } })
    }
  }

  const renderMostRecentMessageDisplay = () => {
    const prefix = theySentMessage ?  '' : 'You: '
    let display = ''
    const trimmed = mostRecentMessage?.body?.trim?.()
    if (typeof mostRecentMessage?.body === 'string' && trimmed) {
      display = prefix + trimmed
    } else if (mostRecentMessage?.media?.[0]?.uuid) {
      display = prefix + 'new image'
    } else if (!!mostRecentMessage) {
      display = <>new message</>
    } else {
      display = <>no messages</>
    }
    return display
  }

  return (
    <div style={{ width: '100%', display: 'flex'}}>
      <ContainerButton
        onClick={handleMessageNavigation}>
        <ProfileNavigateAvatar
          user={user}
          onlineIndicator
          onlineIndPos={{ right: '22.5%', top: '22%' }}
          userStatus={user?.tempStatus}
          isFavorite={conversation?.isFavorite}
          src={thumbnailMediumBlue(user?.nearbyMedia?.thumbnails?.[0], user?.defaultAvatar)}
          uuid={user?.nearbyUuid}
          style={{
            height: '3.45rem',
            width: '3.45rem',
            borderRadius: '100px',
            flexShrink: 0,
            marginRight: '1.2rem',
            filter: isAvatar && 'grayscale(100%) contrast(120%) brightness(65%)'
          }}
        />
        <UserDetails>
          {/* NOTE: The display: 'inline-block' is apparently necessary for the ellipsis overflow... hence the <br /> */}
          <DetailsTop>
            {conversation?.isFavorite &&
              <PiStarFill
                fill={colors.statusColors.meetup('primary')}
                size={size(2)}
                style={{ flexShrink: 0, marginRight: size(0.75), marginBottom: size(0.25) }}
              />
            }
            <DetailsUserName
              style={{ fontWeight: greyBody ? 'normal' : '600', }}
              ref={node => node && clamp(node, {clamp: 1})}>
              {renderUserName()}
            </DetailsUserName>
          </DetailsTop>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: size(0.6), whiteSpace: 'nowrap', overflow: 'hidden', alignItems: 'center' }}>
            <span
              // ref={node => node && clamp(node, {clamp: 1})}
              style={{ fontSize: 14, color: greyBody ? 'grey' : 'white', fontWeight: greyBody ? 'auto' : '600', flexShrink: 1, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: size(23.5) }}>
              {renderMostRecentMessageDisplay()}
            </span>
            <span style={{ display: 'flex', alignItems: 'center', color: greyBody ? 'grey' : 'white', fontSize: 14, fontWeight: greyBody ? 'auto' : '500', flexShrink: 0, flexGrow: 1 }}>
              <div style={{ height: size(0.2), width: size(0.2), backgroundColor: greyBody ? 'grey' : 'white', borderRadius: '100px', margin: `0 ${size(0.35)}` }} />
              {renderDateCreated()}
            </span>
          </div>
        </UserDetails>
        {!greyBody &&
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: size(3), marginLeft: size(1.5) }}>
            <div style={{ backgroundColor: (user?.tempStatus === 'browsing' ? 'white' : userStatusColor), borderRadius: '100%', height: size(1.5), width: size(1.5), flexShrink: 0 }} />
          </div>
        }
      </ContainerButton>
    </div>
  )
}

export default ConversationListItem
